import Pagination from '@/components/Shared/Pagination';
import css from '@/components/ui/shared/Table/TablePaginationBar.module.css';
import { usePaginationFit } from '@/components/ui/shared/Table/usePaginationFit';
import type { ReactNode } from 'react';

export interface TablePaginationBarProps {
  totalRecords: number;
  currentPage: number;
  pageSize: number;
  // Accepted for parity with TablePagination's config shape but unused —
  // Pagination navigates via useSearchParams internally.
  url?: string;
  onChange?: (page: number) => void;
  backgroundColor?: string | null;
}

/**
 * Table's own pagination bar — a thin wrapper around the shared Pagination
 * logic component, styled to line up with the table's own row padding
 * instead of DybrPagination's blog-page padding/breakpoints.
 */
export function TablePaginationBar({
  totalRecords,
  currentPage,
  pageSize,
  backgroundColor
}: TablePaginationBarProps) {
  const { ref, maxFirst } = usePaginationFit<HTMLDivElement>();

  const wrap = (pagination: ReactNode) => (
    <div ref={ref} className={css.pagination} style={backgroundColor ? { backgroundColor } : undefined}>
      {pagination}
    </div>
  );

  return (
    <Pagination
      totalRecords={totalRecords}
      currentPage={currentPage}
      pageSize={pageSize}
      maxFirst={maxFirst}
      wrap={wrap}
    />
  );
}
